export const DeltaXMLColors = {
    CONCRETE: '#F3F3F3',
    CELERY: '#A2C644',
    DARK_CELERY: '#617729',
    FOUNTAIN_BLUE: '#66A1C3',
    OXFORD_BLUE: '#3B495B',
    BLUE_BACKGROUND: '#CBE5FF',
    GREY: '#878787',
    MULBERRY: '#C8476D',
    PIZAZZ: '#F89200',
    MOJO: '#BA5536',
    DARK_BACKGROUND: '#1E252E',
    LIGHT_BACKGROUND: '#F8F8F8',
    ORANGE_BACKGROUND: '#FFF4E5',
    ORANGE: '#F39211',
    RED: ' #EA4D50'
}

export const DeltaJSONColors = {
    BREAKER_BAY: '#66A5AB',
    BLACK: '#000000',
    WHITE: '#FFFFFF',
    MERCURY: '#EAEAEA',
    YELLOW: '#FDCC16'  
}